<script lang="ts">
  import { getWorkflow } from "../../../lib/workflow/workflowLib.svelte";
  import { formatGbp } from "../../../lib/formatting";
  let {
    amount,
    minStep,
    badge = false,
  } : {
    amount: number;
    minStep: number;
    badge?: string | false;
  } = $props();

  const workflow = getWorkflow();
  let { step, totalSteps, caption } = $derived(workflow.state);
  let progress = $derived(Math.min( // Never more than totalSteps
    totalSteps || 1,
    Math.max(step, minStep) // Show general progress when returning to overview screen
  ))
</script>

<div class="flex justify-between items-center -mx-4 -mt-4 p-4 text-emerald-700 bg-gradient-to-bl from-emerald-100 to-[#F8FCFF] rounded-t-lg">
  <div>
    <div>Receive settlement payment</div>
    <div class="text-sm text-gray-500">
      {#if step}Step {step} of {totalSteps}{:else}{caption}{/if}
    </div>
  </div>
  <div class="flex items-center gap-2">
    {#if badge}<div class="badge text-xs font-medium text-sky-700 bg-sky-100">{badge}</div>{/if}
    <div class="text-2xl font-bold">{formatGbp(Math.floor(amount), 0)}</div>
  </div>
</div>
<div class:bg-gray-200={!!progress} class="-mx-4 w-auto h-1 mb-3.5">
  <div class="bg-emerald-500 h-1 transition-all" style="width: {(100 * progress) / (totalSteps || 1)}%"></div>
</div>
